export default "<template>\n    <section>\n        <o-pagination :current=\"2\" :total=\"100\" :per-page=\"10\" />\n    </section>\n</template>\n"